import {Button, Spinner} from 'react-bootstrap'
import {Plus} from 'react-bootstrap-icons'
import {ReactNode} from 'react'
import styles from './FloatingActionButton.module.css'

interface FloatingActionButtonProps {
    loading?: boolean
    disabled?: boolean
    variant?: string
    icon?: ReactNode
    text?: ReactNode
    onClick?: () => void
    ariaLabel?: string
    className?: string
    loadingText?: ReactNode

    [key: string]: unknown
}

const FloatingActionButton = ({
                                  loading = false,
                                  disabled = false,
                                  variant = 'success',
                                  icon = <Plus size={28}/>,
                                  text,
                                  onClick,
                                  ariaLabel,
                                  className = '',
                                  loadingText,
                                  ...props
                              }: FloatingActionButtonProps) => {
    const isDisabled = disabled || loading
    const isExtended = !!text

    return (
        <Button
            variant={variant}
            className={`${styles.fab} ${isExtended ? styles.fabExtended : ''} ${className}`}
            disabled={isDisabled}
            onClick={loading ? undefined : onClick}
            aria-label={ariaLabel || (typeof text === 'string' ? text : '')}
            {...props}
        >
            {loading ? (
                <>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    {loadingText && <span className={`${styles.fabText}`}>{loadingText}</span>}
                </>
            ) : (
                <>
                    {text && <span className={`${styles.fabText}`}>{text}</span>}
                    {icon}
                </>
            )}
        </Button>
    )
}

export default FloatingActionButton
